type CatalogService = {
  id: number;
  channelEnabled?: boolean;
};

export function getEnabledChannelServiceIds(services: CatalogService[] | undefined | null): number[] {
  return (services || []).filter((service) => service.channelEnabled).map((service) => service.id);
}

export function toggleChannelCatalogSelection(currentIds: number[], serviceId: number, checked: boolean): number[] {
  if (checked) {
    return Array.from(new Set([...currentIds, serviceId]));
  }

  return currentIds.filter((id) => id !== serviceId);
}
